import React, { memo, forwardRef } from "react";
import { Box } from "@mui/material";

const CarouselItem = forwardRef( (
  { index, length, item, itemwidthpx, CardComponent = null, ...props },
  ref
) => {
  // Dynamically calculated padding and width for responsive layout
  const padding = itemwidthpx * 0.05;
  const cardWidth = itemwidthpx - padding * 2;

  return (
    <Box
      component="div"
      ref={ref} // Attach the forwarded ref
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        boxSizing: "border-box",
      }}
      sx={{
        width: `100%`,
        padding: `${padding}px`,
        height: "100%",
      }}
    >
      {React.isValidElement(CardComponent)  ? (
         React.cloneElement(CardComponent, {
          index,
          length,
          itemwidthpx: cardWidth,
          ...item,
          ...props,
        })
      ) : (
        // Fallback UI when no valid CardComponent is provided
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
            border: "1px dashed #ccc",
            borderRadius: "8px",
            color: "#888",
            fontSize: "1rem",
            textAlign: "center",
            padding: "1rem",
          }}
        >
          {CardComponent === null ? (
            "No Card Component provided."
          ) : (
            "Invalid Card Component. Please pass a valid React component."
          )}
        </Box>
      )}
    </Box>
  );
});


// Add a display name for better debugging and developer tools support
CarouselItem.displayName = "CarouselItem";

export default memo(CarouselItem);
